const companyMetaData = {
  google: {
    sources: [{ title1: 'Google Environmental Report 2021', url: 'https://www.gstatic.com/gumdrop/sustainability/google-2021-environmental-report.pdf' },
      { title2: 'Google: Our third decade of climate action', url: 'https://blog.google/outreach-initiatives/sustainability/our-third-decade-climate-action-realizing-carbon-free-future/' },
      { title3: 'IPCC Sixth Assessment Report 2022', url: 'https://www.ipcc.ch/report/ar6/wg2/' }],
  },
  meta: {
    sources: [{ title1: 'Climate - Meta Sustainability', url: 'https://sustainability.fb.com/climate/' }, { title2: 'IPCC Sixth Assessment Report 2022', url: 'https://www.ipcc.ch/report/ar6/wg2/' }],
  },
  amazon: {
    sources: [{ title1: 'About Amazon: Sustainable Operations', url: 'https://sustainability.aboutamazon.com/environment/sustainable-operations' },
      { title2: 'IPCC Sixth Assessment Report 2022', url: 'https://www.ipcc.ch/report/ar6/wg2/' }],
  },
  netflix: {
    sources: [{ title1: 'Netflix: Net Zero + Nature', url: 'https://about.netflix.com/en/news/net-zero-nature-our-climate-commitment' },
      { title2: 'IPCC Sixth Assessment Report 2022', url: 'https://www.ipcc.ch/report/ar6/wg2/' }],
  },
  mindgeek: {
    sources: [{ title1: 'IPCC Sixth Assessment Report 2022', url: 'https://www.ipcc.ch/report/ar6/wg2/' }],
    hideCurrentPledge: true,
  },
  ebay: {
    sources: [{ title1: 'eBay Impact 2021 Report', url: 'https://static.ebayinc.com/assets/Uploads/Documents/eBay-Impact-2021-Report.pdf' },
      { title2: 'IPCC Sixth Assessment Report 2022', url: 'https://www.ipcc.ch/report/ar6/wg2/' }],
  },
  microsoft: {
    sources: [{ title1: 'Microsoft: 2021 Environmental Sustainability Report', url: 'https://query.prod.cms.rt.microsoft.com/cms/api/am/binary/RE4RwfV#page=15' },
      { title2: 'IPCC Sixth Assessment Report 2022', url: 'https://www.ipcc.ch/report/ar6/wg2/' }],
  },
  adevinta: {
    sources: [{ title1: 'Adevinta: Sustainability Report 2021', url: 'https://www.adevinta.com/app/uploads/2022/04/Sustainability-Report-2021.pdf' },
      { title2: 'IPCC Sixth Assessment Report 2022', url: 'https://www.ipcc.ch/report/ar6/wg2/' },
    ],
  },
  advancepublications: {
    sources: [{ title1: 'IPCC Sixth Assessment Report 2022', url: 'https://www.ipcc.ch/report/ar6/wg2/' }],
    hideCurrentPledge: true,
  },
  bbc: {
    sources: [{ title1: 'Our Plan: The BBC’s Path to Net Zero', url: 'https://www.bbc.co.uk/sustainability/our-plan/' },
      { title2: 'IPCC Sixth Assessment Report 2022', url: 'https://www.ipcc.ch/report/ar6/wg2/' }],
  },
  ikea: {
    sources: [{ title1: 'IKEA: Becoming climate positive', url: 'https://about.ikea.com/en/sustainability/becoming-climate-positive' },
      { title2: 'IPCC Sixth Assessment Report 2022', url: 'https://www.ipcc.ch/report/ar6/wg2/' }],
  },
  spotify: {
    sources: [{ title1: 'Spotify: Equity Impact Report 2021', url: 'https://www.lifeatspotify.com/reports/Spotify-Equity-Impact-Report-2021.pdf' }, { title2: 'IPCC Sixth Assessment Report 2022', url: 'https://www.ipcc.ch/report/ar6/wg2/' }],
  },
  twitter: {
    sources: [{ title1: 'Twitter: Accelerating our climate commitments on Earth Day', url: 'https://blog.twitter.com/en_us/topics/company/2022/accelerating-our-climate-commitments-on-earth-day' },
      { title2: 'IPCC Sixth Assessment Report 2022', url: 'https://www.ipcc.ch/report/ar6/wg2/' }],
  },
  pinterest: {
    sources: [{ title1: 'IPCC Sixth Assessment Report 2022', url: 'https://www.ipcc.ch/report/ar6/wg2/' }],
    hideCurrentPledge: true,
  },
};

export default companyMetaData;
